"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.omitStyleProps = exports.getStyleProps = void 0;
var props_1 = require("@styled-system/props");
var getStyleProps = function (props) { return (0, props_1.pick)(props); };
exports.getStyleProps = getStyleProps;
var omitStyleProps = function (props) { return (0, props_1.omit)(props); };
exports.omitStyleProps = omitStyleProps;
//# sourceMappingURL=style.js.map